<template>
    <apex-chart type="line" height="350" :options="c_options" :series="c_series"></apex-chart>
</template>

<script>
import ApexChart from 'vue-apexcharts'
export default {
    components:{
        ApexChart,
    },
    props:{
        summary:Array,
    },
    data(){
        return{
            colors:["#1F4690","#36AE7C","#EF5B0C","#ff9f43"]
        }
    },
    computed:{
        c_sortedSummary(){
            let total = this.summary.find(s=> s.Type == "TOPLAM")?.TotalCount
            return this.summary.sort((a, b) =>  b.TotalCount - a.TotalCount).map(s=>{
                return {...s,Ratio:(100*s.TotalCount) / total}
            })
        },
        c_options(){
            let options = {
                chart:{toolbar: {show:false},},
                plotOptions: { bar: { horizontal: false, columnWidth: '55%', }, },
                dataLabels: { enabled: true,enabledOnSeries: [1] },
                stroke: { show: true,  width: 4, colors: ['transparent'] },
                xaxis: { categories: this.c_sortedSummary.filter(s=> s.Type != "TOPLAM").map(s=>s.Type), },
                yaxis: [{}, {opposite: true,min:0,max:100}],
                fill: { opacity: 1 },
            }
            return options
        },
        c_series(){
            return [
                {
                    name:"Toplam Geçis Sayısı",
                    type:"column",
                    color:this.colors[0],
                    data:this.c_sortedSummary.filter(s=> s.Type != "TOPLAM").map(s=>s.TotalCount),
                },
                {
                    name:"Toplam Geçişe Oranı",
                    type:"line",
                    color:this.colors[1],
                    data:this.c_ratios
                }
            ]
        },
        c_ratios(){
            const ratios = this.c_sortedSummary.filter(s=> s.Type != "TOPLAM").map(s=>s.Ratio)
            return ratios.map((elem, index) => ratios.slice(0,index + 1).reduce((a, b) => a + b)).map(s=>parseFloat(s).toFixed(2))
        }
    }
}
</script>

<style>

</style>